import { render } from "./SendFailedRequests.vue?vue&type=template&id=d6778a26"
import script from "./SendFailedRequests.vue?vue&type=script&lang=js"
export * from "./SendFailedRequests.vue?vue&type=script&lang=js"

import "./SendFailedRequests.vue?vue&type=style&index=0&id=d6778a26&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QToolbar,QBtn,QToolbarTitle,QInput});
